"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const Auth_1 = require("../../actions/Auth");
const Button_1 = __importDefault(require("../input/Button"));
const FormErrors_1 = __importDefault(require("../pageParts/FormErrors"));
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const ForgotPasswordPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const submitButtonRef = react_1.default.useRef(null);
    const isAuthenticated = (0, react_redux_1.useSelector)((state) => state.auth.isAuthenticated);
    const emailExists = (0, react_redux_1.useSelector)((state) => state.auth.emailExists);
    const [formState, setFormState] = react_1.default.useState({
        email: '',
        error: undefined
    });
    const validateEmail = (email) => {
        if (!email) {
            return 'auth:missingEmail';
        }
        if (!emailRegex.test(email)) {
            return 'auth:invalidEmail';
        }
        return undefined;
    };
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { email })));
    };
    const handleSubmit = () => {
        const error = validateEmail(formState.email);
        if (error) {
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { error })));
            return;
        }
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { error: undefined })));
        dispatch((0, Auth_1.startForgotPasswordRequest)({
            email: formState.email
        }));
    };
    const handleKeyPress = (e) => {
        var _a;
        if (e.key === 'Enter' || e.which === 13) {
            (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const buttonProps = {
        isVisible: true,
        align: 'center',
        onClick: handleSubmit
    };
    if (emailExists) {
        return (react_1.default.createElement("div", { className: "apptr__form apptr__form-auth apptr__form__label-standalone" },
            react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t('auth:forgotPasswordEmailConfirmation')),
            react_1.default.createElement("div", { className: "apptr__footer-link-container" },
                react_1.default.createElement(react_router_1.Link, { className: "apptr__footer-link _oblique", to: "/login" }, t('auth:BackToLoginPage')))));
    }
    return (react_1.default.createElement("form", { className: "apptr__form apptr__form-auth", onKeyPress: handleKeyPress, onSubmit: (e) => e.preventDefault() },
        react_1.default.createElement("div", { className: "apptr__form-label-container center" },
            react_1.default.createElement("div", { className: "apptr__form__label-standalone" },
                react_1.default.createElement("p", null, t('auth:pleaseEnterYourAccountEmail'))),
            formState.error && react_1.default.createElement(FormErrors_1.default, { errors: [formState.error] }),
            emailExists === false && !isAuthenticated && react_1.default.createElement(FormErrors_1.default, { errors: ['auth:emailDoesNotExist'] })),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("div", { className: "apptr__form-label-container" },
                    react_1.default.createElement("label", { htmlFor: "email", className: "_flex" }, t('auth:Email'))),
                react_1.default.createElement("input", { name: "email", id: "email", type: "text", inputMode: "email", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", autoFocus: true, value: formState.email, onChange: handleEmailChange }))),
        react_1.default.createElement(Button_1.default, Object.assign({}, buttonProps, { inputRef: submitButtonRef, label: t('auth:forgotPassword') })),
        react_1.default.createElement("div", { className: "apptr__separator-medium" }),
        react_1.default.createElement("div", { className: "apptr__footer-link-container" },
            react_1.default.createElement(react_router_1.Link, { className: "apptr__footer-link _oblique", to: "/login" }, t('auth:Cancel')))));
};
exports.default = ForgotPasswordPage;
//# sourceMappingURL=ForgotPasswordPage.js.map